









































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  listRoles,
  updateRole,
  deleteRole,
  createRole,
  listPermissions,
  getPermissionsByRole,
  addPermissionToRole,
} from "@/services/auth";
import { Permission, isValidPermission } from "@/models/IPermission";
@Component
export default class RolePermission extends Vue {
  // private permissions: Permission[] = [];

  private allPermissions: Permission[] = [];
  private permissionMap: Map<string, any> = new Map();
  private permission: any = null;
  private roles: any[] = [];
  public search = "";
  private headers: any = [
    {
      text: "Name",
      align: "left",
      sortable: false,
      value: "name",
    },
    {
      text: "Resource",
      value: "resource",
      sortable: false,
    },
    {
      text: "Method",
      value: "action",
    },
    {
      text: "Actions",
    },
  ];

  get role() {
    return this.$route.query.role;
  }

  get permissions() {
    const allPermissionsResult =
      this.$store.getters["permission/GetAllPermissionList"];
    this.allPermissions = allPermissionsResult;
    const permissionsResult =
      this.$store.getters["permission/GetPermissionListByRole"];
    let rolePermissions: any = [];
    permissionsResult.map((Obj) => {
      let newobj = this.allPermissions.find((p) => p._id === Obj.permission);
      if (newobj) {
        let data = {
          action: newobj.action,
          name: newobj.name,
          resource: newobj.resource,
          _id: Obj._id,
        };
        rolePermissions.push(data);
      }
    });
    return rolePermissions;

    // ------- OLD Logic ------- /////////

    // const permissions = permissionsResult;
    // const allPermissions = allPermissionsResult;
    // const permissionMap = new Map<string, any>(
    //   allPermissions.map(p => [p._id, p])
    // );
    // const rolePermissions = permissions.map(p =>
    //   permissionMap.get(p.permission)
    // );
    // rolePermissions.map(Obj => {
    //   permissionsResult.map(permission => {
    //     if (Obj._id) {
    //       if (Obj._id === permission.permission) {
    //         Obj["permission_id"] = permission._id;
    //       } else {
    //         Obj["permission_id"] = Obj._id;
    //       }
    //     }
    //   });
    // });
  }
  // Vue instance mounted method
  public async mounted() {
    const role = this.role;
    if (this.$store.getters["permission/GetAllPermissionList"].length === 0) {
      this.$store.dispatch("permission/fetchAllPermission");
    }
    await this.$store.dispatch("permission/getPermissionsByRole", role);
  }
  // Add permission to role function
  private async addPermmission() {
    let isPermissionAdded = this.permissions.some(
      (obj) => obj.name === this.permission.name
    );
    if (isPermissionAdded) {
      this.$toasted.info("Permission is already added!");
    } else {
      this.$store
        .dispatch("permission/addPermissionToRole", {
          role: this.role as string,
          permission: this.permission._id,
        })
        .then((result) => {
          this.$store.dispatch("permission/getPermissionsByRole", this.role);
          this.$toasted.success("Permission added to Role!");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  // delete specific permission from role.
  async deletePermission(data) {
    await this.$swal({
      title: "Are you sure?",
      text: "You can't revert this action!!",
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      
    }).then((result) => {
      if (result.value) {
        this.$store
          .dispatch("permission/removePermissionToRole", data._id)
          .then((res: any) => {
            this.$toasted.success("Deleted!");
            this.$store.dispatch("permission/getPermissionsByRole", this.role);
          });
      }
    });
  }
}
